import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";


import { usePitchWorkspace } from "~/modules/main/hooks/use-pitch-workspace/use-pitch-workspace";

import { usePitchDetails } from "~/modules/main/hooks/use-pitch-details/use-pitch-details";


/**
 * Domain hook implementations
 * 
 * This is a collection of all the domain hooks that are available in the application.
 * It is used to provide the domain hooks to the application.
 * 
 * You can access them by using the `useDomainHooks` hook.
 */
export const domainHooksRegistry: DomainHooksRegistryInterface = {

    usePitchWorkspace: usePitchWorkspace,

    usePitchDetails: usePitchDetails,

} as DomainHooksRegistryInterface;